import { Image } from 'antd';
import { useEffect, useState } from 'react';

const TaskPhotos = (props: { imageArray: string[]; startIndex: number }) => {
    const [newPhotos, setNewPhotos] = useState<string[][]>([]);
    const [firstPagePhotos, setFirstPagePhotos] = useState<string[][]>([]);
    const [lastPagePhotos, setLastPagePhotos] = useState<string[][]>([]);
    const [pageIndex, setPageIndex] = useState(1);
    useEffect(() => {
        const lists: string[][] = [];
        let list: string[] = [];
        let startIndex = props.startIndex;
        props.imageArray.forEach((i, index) => {
            if (index + 1 < startIndex) {
                list.push(i);
                if (index + 1 === props.imageArray.length) {
                    lists.push([...list]);
                }
            } else {
                lists.push([...list, i]);
                list = [];
                startIndex = startIndex + props.startIndex;
            }
        });
        setNewPhotos(lists);
    }, [props.imageArray]);
    useEffect(() => {
        if (newPhotos.length) {
            const first = newPhotos.slice(0, 2);
            setFirstPagePhotos(first);
            if (newPhotos.length > 2) {
                const last = newPhotos.slice(2, 4);
                setLastPagePhotos(last);
            }
        }
    }, [newPhotos]);
    return (
        <div className="content-card photo-com">
            <div className="flex-between">
                <div className="card-title">Photos</div>
                {props.imageArray.length > 6 ? (
                    <div className="next-btn">
                        <img
                            style={{
                                cursor: pageIndex === 1 ? 'no-drop' : 'pointer',
                                opacity: pageIndex === 1 ? 0.5 : 1,
                            }}
                            src={require('@/assets/images/left-icon.png')}
                            alt=""
                            onClick={() => {
                                setPageIndex(1);
                            }}
                        />
                        <img
                            style={{
                                cursor: pageIndex === 2 ? 'no-drop' : 'pointer',
                                opacity: pageIndex === 2 ? 0.5 : 1,
                            }}
                            src={require('@/assets/images/right-icon.png')}
                            alt=""
                            onClick={() => {
                                setPageIndex(2);
                            }}
                        />
                    </div>
                ) : (
                    ''
                )}
            </div>
            {pageIndex === 1 &&
                firstPagePhotos.map((imgArr, index) => {
                    return (
                        <div
                            className={imgArr.length > 1 ? 'task-photos more-photos' : 'task-photos one-photo'}
                            key={'firstPagePhotos' + index}
                        >
                            {imgArr.map((i, index) => {
                                return <Image key={'task-photo' + index} src={i} />;
                            })}
                        </div>
                    );
                })}
            {pageIndex === 2 &&
                lastPagePhotos.map((imgArr, index) => {
                    return (
                        <div
                            className={imgArr.length > 1 ? 'task-photos more-photos' : 'task-photos one-photo'}
                            key={'lastPagePhotos' + index}
                        >
                            {imgArr.map((i, index) => {
                                return <Image key={'task-photo' + index} src={i} />;
                            })}
                        </div>
                    );
                })}
        </div>
    );
};
export default TaskPhotos;
